// Shared constants

/**
 * local storage key used to store the tenant identifier
 */
export const localStorageUASTenantKey = 'uasTenantUriComponent';
